<script setup lang="ts">
import BackendUnreachable from "@/ui/components/BackendUnreachable.vue";
</script>

<template>
	<div>
		<router-view />
		<BackendUnreachable />
	</div>
</template>

<style scoped lang="scss"></style>
